var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4966 0.931172C30.6963 0.109757 29.5118 -0.196261 28.4074 0.125863L2.65282 7.61524C1.48754 7.93897 0.661604 8.8683 0.439113 10.0489C0.21182 11.2504 1.00574 12.7757 2.04297 13.4135L10.0959 18.3629C10.9218 18.8702 11.9878 18.743 12.6713 18.0537L21.8927 8.77488C22.3569 8.2917 23.1252 8.2917 23.5894 8.77488C24.0536 9.24196 24.0536 9.99895 23.5894 10.4821L14.352 19.7625C13.6669 20.4503 13.5389 21.5213 14.0431 22.3524L18.9635 30.486C19.5397 31.4524 20.5321 32 21.6206 32C21.7486 32 21.8927 32 22.0207 31.9839C23.2693 31.8228 24.2617 30.9692 24.6298 29.7612L32.2649 4.03967C32.6011 2.94445 32.297 1.75259 31.4966 0.931172",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.a6afc00c4e41c031b1bc165a66876e81.svg";
export { ForwardRef as ReactComponent };